import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";

// get user

export const getUser = createAsyncThunk(
  "user/getUser",
  async (data, { rejectWithValue }) => {
    const { rowsPerPage, pageNo } = data;
    try {
      const { data } = await API.getUser({ rowsPerPage, pageNo });
      return data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message ||
          "An error occurred while fetching users."
      );
    }
  }
);

// get previous
export const getPrevious = createAsyncThunk(
  "user/getPrevious",
  async (previous, { rejectWithValue }) => {
    try {
      const { data } = await API.getPrevious(previous);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.errors[0]?.error);
    }
  }
);
// get next
export const getNext = createAsyncThunk(
  "user/getNext",
  async (next, { rejectWithValue }) => {
    try {
      const { data } = await API.getNext(next);

      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.errors[0]?.error);
    }
  }
);

// get particular page
export const getParticularPage = createAsyncThunk(
  "user/getParticularPage",
  async (data, { rejectWithValue }) => {
    const { number, postsPerPage } = data;

    try {
      const { data } = await API.getPageUser(number, postsPerPage);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.errors[0]?.error);
    }
  }
);

// create user
export const createUser = createAsyncThunk(
  "user/createUser",
  async (data, { rejectWithValue }) => {
    try {
      const body = JSON.stringify({ ...data });
      const response = await API.createUser(body);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || "An error occurred while creating the User."
      );
    }
  }
);

// delete user
export const deleteUser = createAsyncThunk(
  "user/deleteUser",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await API.deleteUser(id);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// handle search
export const handleSearch = createAsyncThunk(
  "user/handleSearch",
  async (data, { rejectWithValue }) => {
    const { search, rowsPerPage } = data;
    console.log(data);
    try {
      const { data } = await API.handleSearch({ search, rowsPerPage });
      return data;
    } catch (error) {
      console.error("Error searching users:", error);
      return rejectWithValue(
        error?.response?.data?.message ||
          "An error occurred while searching users."
      );
    }
  }
);
